import React, {
    useEffect,
} from "react";

import ReactDOM
    from "react-dom";

import {
    FiX,
} from "react-icons/fi";


const BusinessModal = ({
    open = false,

    title = "",

    description = "",

    eyebrow = "PLATFORM BUSINESS",

    children,

    footer = null,

    onClose,

    disableClose = false,

    closeOnBackdrop = true,

    size = "lg",
}) => {

    /*
    |--------------------------------------------------------------------------
    | BODY LOCK + ESC
    |--------------------------------------------------------------------------
    */

    useEffect(
        () => {

            if (
                !open
            ) {

                return undefined;

            }


            const previousOverflow =
                document.body.style.overflow;


            document.body.style.overflow =
                "hidden";


            const handleKeyDown =
                (
                    event
                ) => {

                    if (
                        event.key ===
                        "Escape" &&
                        !disableClose
                    ) {

                        onClose?.();

                    }

                };


            document.addEventListener(
                "keydown",
                handleKeyDown
            );


            return () => {

                /*
                |--------------------------------------------------------------------------
                | ALWAYS RESTORE BODY
                |--------------------------------------------------------------------------
                */

                document.body.style.overflow =
                    previousOverflow;


                document.removeEventListener(
                    "keydown",
                    handleKeyDown
                );

            };

        },
        [
            open,
            disableClose,
            onClose,
        ]
    );


    /*
    |--------------------------------------------------------------------------
    | NOT OPEN
    |--------------------------------------------------------------------------
    */

    if (
        !open
    ) {

        return null;

    }


    /*
    |--------------------------------------------------------------------------
    | MODAL CONTENT
    |--------------------------------------------------------------------------
    */

    const modalContent = (

        <div
            className="platform-business-modal-backdrop"

            onMouseDown={(
                event
            ) => {

                if (
                    !closeOnBackdrop ||
                    disableClose
                ) {

                    return;

                }


                /*
                |--------------------------------------------------------------------------
                | ONLY BACKDROP
                |--------------------------------------------------------------------------
                */

                if (
                    event.target ===
                    event.currentTarget
                ) {

                    onClose?.();

                }

            }}
        >

            <div
                className={`platform-business-modal platform-business-modal-${size}`}

                role="dialog"

                aria-modal="true"

                aria-label={
                    title ||
                    "Business dialog"
                }

                onMouseDown={(
                    event
                ) => {

                    /*
                    |--------------------------------------------------------------------------
                    | PREVENT MODAL CLICK FROM REACHING BACKDROP
                    |--------------------------------------------------------------------------
                    */

                    event.stopPropagation();

                }}
            >

                {/*
                |--------------------------------------------------------------------------
                | HEADER
                |--------------------------------------------------------------------------
                */}

                <div className="platform-business-modal-header">

                    <div>

                        {eyebrow ? (

                            <span className="platform-business-modal-eyebrow">

                                {
                                    eyebrow
                                }

                            </span>

                        ) : null}


                        {title ? (

                            <h2>

                                {
                                    title
                                }

                            </h2>

                        ) : null}


                        {description ? (

                            <p>

                                {
                                    description
                                }

                            </p>

                        ) : null}

                    </div>


                    <button
                        type="button"

                        className="platform-business-modal-close"

                        onClick={() => {

                            if (
                                !disableClose
                            ) {

                                onClose?.();

                            }

                        }}

                        disabled={
                            disableClose
                        }

                        aria-label="Close"
                    >

                        <FiX />

                    </button>

                </div>


                {/*
                |--------------------------------------------------------------------------
                | CONTENT
                |--------------------------------------------------------------------------
                */}

                <div className="platform-business-modal-content">

                    {
                        children
                    }

                </div>


                {/*
                |--------------------------------------------------------------------------
                | OPTIONAL FOOTER
                |--------------------------------------------------------------------------
                */}

                {footer ? (

                    <div className="platform-business-modal-footer">

                        {
                            footer
                        }

                    </div>

                ) : null}

            </div>

        </div>

    );


    /*
    |--------------------------------------------------------------------------
    | PORTAL
    |--------------------------------------------------------------------------
    |
    | Critical fix:
    |
    | Modal is rendered under document.body rather than PlatformLayout.
    |
    | This prevents:
    |
    | overflow:hidden
    | transform
    | z-index
    | stacking-context
    |
    | issues from hiding the modal.
    |--------------------------------------------------------------------------
    */

    return ReactDOM.createPortal(

        modalContent,

        document.body

    );

};


export default BusinessModal;